import React from "react";
import styles from "./ErrorModule.module.css";
import { ThreeDots } from "react-loader-spinner";
import Button from "@/components/atoms/Button/Button";

interface ErrorModuleProps {
  title: string;
  description: string;
  dismiss: () => void;
  contactSupport: () => void;
}

const ErrorModule = ({
  title,
  description,
  dismiss,
  contactSupport,
}: ErrorModuleProps) => {
  return (
    <div className={styles.container}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        style={{ margin: "20px" }}
      >
        <rect width="64" height="64" rx="32" fill="#FEE6E2" />
        <path
          d="M32.0002 58.6666C17.2726 58.6666 5.3335 46.7274 5.3335 31.9999C5.3335 17.2723 17.2726 5.33325 32.0002 5.33325C46.7276 5.33325 58.6668 17.2723 58.6668 31.9999C58.6668 46.7274 46.7276 58.6666 32.0002 58.6666ZM29.3335 39.9999V45.3332H34.6668V39.9999H29.3335ZM29.3335 18.6666V34.6666H34.6668V18.6666H29.3335Z"
          fill="#FB836F"
        />
      </svg>
      <div className={styles.error_info}>
        <h3>{title}</h3>
        <p>{description}</p>
      </div>
      <div className={styles.btn_container}>
        <Button onClick={dismiss}>Dismiss</Button>
        <Button onClick={contactSupport} variant={"ghost"}>Contact Support</Button>
      </div>
    </div>
  );
};

export default ErrorModule;
